import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import ArrowLeft from '../../../Icons/ArrowLeft';
import FolderTabs from '../FolderTabs';
import FolderList from '../FolderList';
import s from './DesktopLayout.scss';
export var DesktopGroupFolderList = function (_a) {
    var onResetSelectedGroup = _a.onResetSelectedGroup, selectedGroup = _a.selectedGroup, selectedSubmissionType = _a.selectedSubmissionType, onSubmissionTypeSelected = _a.onSubmissionTypeSelected, onFolderSelected = _a.onFolderSelected, deviationId = _a.deviationId;
    var t = useTranslation().t;
    return (React.createElement("div", { className: s['folder-list'] },
        React.createElement("button", { className: s['back'], onClick: onResetSelectedGroup },
            React.createElement(ArrowLeft, null)),
        React.createElement("div", { className: s['header'] },
            React.createElement("span", null,
                React.createElement(Trans, { i18nKey: "addToGroup.addToAGroup" },
                    "Add to ",
                    React.createElement("span", { className: s['username'] }, { username: selectedGroup.username }),
                    " group")),
            React.createElement("span", { className: s['hint'] }, t('addToGroup.chooseAnyFolder'))),
        React.createElement(FolderTabs, { selectedSubmissionType: selectedSubmissionType, onSubmissionTypeSelected: onSubmissionTypeSelected }),
        React.createElement("div", { className: s['card-list'] },
            React.createElement(FolderList, { key: selectedSubmissionType, deviationId: deviationId, groupId: selectedGroup.userId, submissionType: selectedSubmissionType, onFolderSelected: onFolderSelected }))));
};
DesktopGroupFolderList.displayName = 'DesktopGroupFolderList';
export default DesktopGroupFolderList;
//# sourceMappingURL=DesktopGroupFolderList.js.map